import { BlobArray, CacheFunction } from "@pdfking/compatibility"
import { FileContentGUID, type VirtualFile } from "@pdfking/pdfengine"
import { IterableToArray } from "@pdfking/tfunc"

import { RequestBlob } from "./Functions"

export const BlobUrl = CacheFunction(
  (file: VirtualFile): Promise<string> =>
    RequestBlob(file)
      .then(({ stream }) => IterableToArray(stream))
      .then(BlobArray)
      .then(blob => blob.createObjectURL()),
  FileContentGUID
)
